import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_view: false,

      search: "",

      data: [],
      count: 0,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let result = await GET("admin/manage/customers/list", { page: page, data_search: this.state.search });
    if (result?.status) {
      this.setState({ data: result.data, count: result.count });
    }
    loading(false);
  };
  render() {
    const {modal_view, search, data, count} = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div>
              <h4 className="fw-bold mb-3 me-3" onClick={()=>{this.setState({modal_view:true})}}>แผนที่แปลง</h4>
              <div className="rounded-4 overflow-hidden" style={{ height: "80vh" }}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3787.6620210759834!2d99.3986862!3d18.3170581!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30d96f264a1dd1f9%3A0xf0346c6d9b33150!2z4Lih4Lir4Liy4Lin4Li04LiX4Lii4Liy4Lil4Lix4Lii4LiY4Lij4Lij4Lih4Lio4Liy4Liq4LiV4Lij4LmMIOC4qOC4ueC4meC4ouC5jOC4peC4s-C4m-C4suC4hw!5e0!3m2!1sth!2sth!4v1744017608809!5m2!1sth!2sth" width="100%" height="100%" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
          </div>
        </div>
         {/* VIEW */}
                <Modal show={modal_view} onHide={() => this.setState({ modal_view: false })}>
                  <Modal.Header closeButton>
                    <h4 className="mb-0">รายละเอียด</h4>
                  </Modal.Header>
                  <Modal.Body className="pb-0">
                    <div className="row">
                      <div className="col-6 mb-3"><div>เลขโควต้า</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ชื่อ - นามสกุล</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ปีการผลิต</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>โครงการ</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ประเภทพื้นที่</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ประเภทอ้อย</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>เลขแปลง FID</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>เอกสารสิทธิ์</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ข้อมูลพื้นที่</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ประเภทดิน</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>พื้นที่</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>การใช้ประโยชน์ก่อนหน้านี้</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>จุดอ้างอิง/ชื่อแปลง</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>แหล่งน้ำ</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>วืธีการให้น้ำ</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ความต้องการรถไถ</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ความต้องการพันธุ์อ้อย</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ประเภทร่อง</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ระยะร่อง</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>พันธุ์อ้อย</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ประเภทการตัด</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ทิศทางร่องอ้อย</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ความลาดเอียงของแปลง</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ความยาวของแถวอ้อย</div><div>-</div></div>
                      <div className="col-6 mb-3"><div>ความสูงของแปลง</div><div>-</div></div>
                    </div>
                  </Modal.Body>
                </Modal>
      </div>
    );
  }
}
